import { useTranslation } from "react-i18next";
import { useAppStore } from "@/app/hooks";
import { fetchLayerConfig } from "@/features/layout-design/layerConfig";
import { selectCurrentConfiguration, selectPlanValue } from "@/features/shell/legacySelectors";
import { openPreview, PreviewPopupBlockedError, type OpenPreviewOptions } from "@/shared/lib/preview";
import { useToast } from "@/shared/ui";
import { ExternalLink } from "@/shared/ui/icons";

export function PreviewButton({ openWindow }: { openWindow?: OpenPreviewOptions["openWindow"] }) {
  const { t } = useTranslation();
  const store = useAppStore();
  const toast = useToast();

  const toPreview = async () => {
    try {
      await openPreview(
        async () => {
          const state = store.getState();
          const config = await fetchLayerConfig(store.dispatch, selectCurrentConfiguration(state));
          return { ...config, isActive: selectPlanValue(state).isActive };
        },
        openWindow ? { openWindow } : {},
      );
    } catch (error) {
      toast.error(
        t(
          error instanceof PreviewPopupBlockedError
            ? "saveChanges.previewPopupBlocked"
            : "saveChanges.previewError",
        ),
        { title: t("saveChanges.previewErrorTitle") },
      );
    }
  };

  return (
    <button
      type="button"
      className="preview-button btn btn-sm h-9 gap-2 border-base-300 bg-base-100 px-3 text-secondary shadow-none hover:border-primary hover:bg-primary/5 hover:text-primary"
      onClick={() => void toPreview()}
    >
      <ExternalLink className="size-4" aria-hidden="true" />
      <span>{t("saveChanges.seePreview")}</span>
    </button>
  );
}
